export default __webpack_public_path__ + "static/Plots0006-228d5afdd609968666ce69aeca675e80.jpg";